"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Settings } from "lucide-react";

// Gear de configurações sensível ao contexto: dentro do painel de gestor
// (/gestor*) aponta para /gestor/configuracoes, mantendo a navegação de equipe.
export function ConfigButton({ className = "" }: { className?: string }) {
  const pathname = usePathname();
  const href = pathname.startsWith("/gestor") ? "/gestor/configuracoes" : "/configuracoes";

  return (
    <Link
      href={href}
      prefetch
      aria-label="Abrir configurações"
      title="Configurações"
      className={`flex h-11 w-11 items-center justify-center rounded-xl border border-border text-muted transition-colors hover:text-navy lg:h-12 lg:w-12 lg:rounded-2xl ${className}`}
    >
      <Settings className="h-[18px] w-[18px]" />
    </Link>
  );
}
